// A device frame on desktop; full-width application on a phone.
export default function PhoneFrame({ children }) {
    return (
        <div className="w-full sm:max-w-[418px] sm:rounded-[2.5rem] sm:bg-slate-900 sm:p-3 sm:shadow-xl" data-testid="phone-frame">
            <div className="w-full h-dvh sm:h-[min(844px,calc(100dvh-88px))] sm:min-h-[480px] sm:rounded-[1.8rem] overflow-hidden bg-white">
                {children}
            </div>
        </div>
    );
}